
// import bangaloreImage from '../assets/Place.jpg'; // Adjust the path based on your folder structure
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
// import { MdOutlineArrowOutward } from 'react-icons/md';

// const SpotToVisit = () => {
//   const places = [
//     { id: 1, name: 'Bangalore', image: bangaloreImage },
//     { id: 2, name: 'Bangalore', image: bangaloreImage },
//     { id: 3, name: 'Bangalore', image: bangaloreImage },
//     { id: 4, name: 'Bangalore', image: bangaloreImage },
//   ];

//   return (
//     <div className="max-w-screen-xl mx-auto px-4 py-8">
//       <h2 className="text-3xl font-semibold text-center text-[#FF9630] mb-8">
//         Spot to visit <span className="text-[#FF9630]">•</span>
//       </h2>

//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
//         {places.map((place) => (
//           <div key={place.id} className="flex flex-col items-center">
//             {/* Image Card */}
//             <div className="relative bg-white rounded-lg overflow-hidden transition-shadow w-full">
//               <img
//                 src={place.image}
//                 alt={`Scenic view of ${place.name}`}
//                 className="w-full h-48 object-cover"
//               />
//               <div className="absolute top-2 right-2 flex items-center gap-1 bg-white text-[#FF9630] text-xs font-semibold py-1 px-2 rounded cursor-pointer hover:bg-white">
//                 MAP <MdOutlineArrowOutward className="text-[#FF9630]" />
//               </div>
//             </div>
//             {/* Place Name */}
//             <div className="mt-2 text-lg font-medium text-gray-700">{place.name}</div>
//           </div>
//         ))}
//       </div>

//       <div className="flex justify-center items-center mt-6">
//         <button className="p-2 text-[#FF9630]" aria-label="Previous">
//           <FontAwesomeIcon icon={faChevronLeft} className="h-5 w-5" />
//         </button>
//         <button className="text-[#FF9630] border border-[#FF9630] px-4 py-2 mx-2 rounded-full hover:bg-[#FF9630] hover:text-white transition-colors">
//           View All
//         </button>
//         <button className="p-2 text-[#FF9630]" aria-label="Next">
//           <FontAwesomeIcon icon={faChevronRight} className="h-5 w-5" />
//         </button>
//       </div>
//     </div>
//   );
// };

// export default SpotToVisit;

import { useNavigate } from 'react-router-dom'; // Import useNavigate
import bangaloreImage from '../assets/Place.jpg'; // Adjust the path based on your folder structure
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { MdOutlineArrowOutward } from 'react-icons/md';

const SpotToVisit = () => {
  const navigate = useNavigate(); // Initialize useNavigate

  const places = [
    { id: 1, name: 'Bangalore', image: bangaloreImage },
    { id: 2, name: 'Bangalore', image: bangaloreImage },
    { id: 3, name: 'Bangalore', image: bangaloreImage },
    { id: 4, name: 'Bangalore', image: bangaloreImage },
  ];

  return (
    <div className="max-w-screen-2xl mx-auto px-4 md:px-16 py-8">
      <h2 className="md:text-4xl text-3xl font-semibold text-center text-[#FF9630] mb-8">
        Spot To Visit <span className="text-[#FF9630]"></span>
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
        {places.map((place) => (
          <div key={place.id} className="flex flex-col items-center">
            {/* Image Card */}
            <div className="relative bg-white rounded-lg overflow-hidden transition-shadow w-full">
              <img
                src={place.image}
                alt={`Scenic view of ${place.name}`}
                className="w-full h-48 object-cover"
              />
              <div className="absolute top-2 right-2 flex items-center gap-1 bg-white text-[#FF9630] text-xs font-semibold py-1 px-2 rounded cursor-pointer hover:bg-white">
                MAP <MdOutlineArrowOutward className="text-[#FF9630]" />
              </div>
            </div>
            {/* Place Name */}
            <div className="mt-2 text-lg font-medium text-gray-700">{place.name}</div>
          </div>
        ))}
      </div>

      <div className="flex justify-center items-center mt-6">
        <button className="p-2 text-[#FF9630]" aria-label="Previous">
          <FontAwesomeIcon icon={faChevronLeft} className="h-5 w-5" />
        </button>
        {/* View All Button */}
        <button
          className="text-[#FF9630] border border-[#FF9630] px-4 py-2 mx-2 rounded-full hover:bg-[#FF9630] hover:text-white transition-colors"
          onClick={() => navigate('/places')} // Redirect to the new route
        >
          View All
        </button>
        <button className="p-2 text-[#FF9630]" aria-label="Next">
          <FontAwesomeIcon icon={faChevronRight} className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};

export default SpotToVisit;
